
export const Tables = (props) => {
    return (
        <table className="table p-table-global text-center">
            <thead className='p-thead-global'>
                <tr className="text-center p-tr-titles-global">
                    {props?.header.map((item, index) => (
                        <th key={index}>{item}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {props?.rows}
            </tbody>
        </table>
    )
}